/* import __COLOCATED_TEMPLATE__ from './reporting-synthetic-data.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
/* eslint-disable @intercom/intercom/no-bare-strings */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type ReportingChartService from 'embercom/services/reporting-chart-service';
import { action } from '@ember/object';

interface Signature {
  Args: any;
}
export default class ReportingSyntheticData extends Component<Signature> {
  // eslint-disable-next-line @intercom/intercom/service-allow-list
  @service declare reportingChartService: ReportingChartService;

  @action
  selectUseCase(useCase: string) {
    this.reportingChartService.setSyntheticDataUseCase(useCase);
  }

  get selectedUseCase() {
    return this.reportingChartService.syntheticDataUseCase;
  }

  get useCases() {
    return [
      {
        name: 'Default',
        value: 'default',
      },
      {
        name: 'Music SaaS',
        value: 'music_saas',
      },
      {
        name: 'Education',
        value: 'education',
      },
      {
        name: 'Healthcare',
        value: 'healthcare',
      },
      {
        name: 'Crypto',
        value: 'crypto',
      },
      {
        name: 'Fin Tech',
        value: 'fin_tech',
      },
      {
        name: 'Ecommerce',
        value: 'ecommerce',
      },
      {
        name: 'Audio products',
        value: 'audio_products',
      },
      {
        name: 'Design platform',
        value: 'design_platform',
      },
      {
        name: 'Buyer-Seller marketplace',
        value: 'buyer_seller_marketplace',
      },
      {
        name: 'Gaming',
        value: 'gaming',
      },
      {
        name: 'Gambling',
        value: 'gambling',
      },
    ];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::UserMenu::ReportingSyntheticData': typeof ReportingSyntheticData;
    'inbox2/user-menu/reporting-synthetic-data': typeof ReportingSyntheticData;
  }
}
